
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-of-service/individual",
      function () {
        return require("private-next-pages/terms-of-service/individual/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-of-service/individual"])
      });
    }
  